import React, { useRef } from 'react';
import cx from 'classnames';
import { AutoComplete as AntdAutoComplete } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

import { sleep } from 'utils/promise';
import { InputSearch } from 'components/FormFields';

import classes from './AutoComplete.module.scss';

const AutoComplete = props => {
  const {
    className,
    children,
    inputSize = 'large',
    loading,
    placeholder = 'Search...',
    clearIcon,
    onClear = () => {},
    ...other
  } = props;
  const inputRef = useRef(null);
  const handleInputClick = async e => {
    await sleep(0);
    inputRef.current.select();
  };
  return (
    <div
      className={cx(
        classes.outerWrapper,
        {
          [classes.hasClearIcon]: !!clearIcon,
        },
        className
      )}
    >
      <AntdAutoComplete {...other} className={cx(classes.wrapper)}>
        {children || (
          <InputSearch
            placeholder={placeholder}
            size={inputSize}
            loading={loading}
            onClick={handleInputClick}
            ref={inputRef}
          />
        )}
      </AntdAutoComplete>
      {!!clearIcon && (
        <CloseCircleOutlined className={classes.clearIcon} onClick={onClear} />
      )}
    </div>
  );
};

export default AutoComplete;
